import React, { memo, useEffect, useMemo } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { validators } from "investira.sdk";
import {
  Button,
  Icon,
  Stack,
  Typography,
  IconButton,
  useMediaQuery,
  Tooltip,
} from "investira.react.components";
import { PageTemplate } from "../../components/templates";
import { useRelatorioContext } from "../../contexts/RelatorioContext";
import { OUTPUT } from "../../enums";
import withReports from "../../hoc/withReports";
import withOutput from "../../hoc/withOutput";
import ConsultaEnquadramento from "./_components/ConsultaEnquadramento";
import ConsultaSkeleton from "./_components/ConsultaSkeleton";

const ReportsConsulta = memo((props) => {
  const params = useParams();
  // const navigate = useNavigate();
  // const location = useLocation();

  const { actions } = useRelatorioContext();

  // const isUpSm = useMediaQuery((theme) => theme.breakpoints.up("sm"));

  useEffect(() => {
    actions.handleOutputUpdate(params.output);
  }, [params.output]);

  return (
    <PageTemplate
      title={"Consulta"}
      scrollable={true}
      subtitle={OUTPUT[params.output].descricao}
      headerRenderActions={
        <Stack direction="row" spacing={2}>
          <Button
            disabled={true || props.isProcessing}
            variant="contained"
            color="primary"
            startIcon={<Icon iconName="execute" size={16} />}
            size="small"
            sx={{ px: 2 }}
            onClick={props.onNewReportClick}
          >
            Gerar Relatório
          </Button>
        </Stack>
      }
    >
      {props.isProcessing ? (
        <ConsultaSkeleton />
      ) : (
        <ConsultaEnquadramento data={props.data} />
      )}
    </PageTemplate>
  );
});

ReportsConsulta.displayName = "ReportsConsulta";

export default withReports(withOutput(ReportsConsulta));
